// Nextsj blog
import React from 'react';
import LatestBlog from './LatestBlog';
import Container from 'common/components/UI/Container';
import { BannerWrapperNav } from '../../../containers/SaasModern/Banner/banner.style';
import LeftInfo from './Content';
import RightInfo from './RightInfo';
import { BlogContainer } from './blog.style';

export default function Blog({ data, author }) {
  return (
    <>
      <BannerWrapperNav />
      <BlogContainer>
        <Container width={'70%'}>
          <LeftInfo data={data} author={author} />
          <RightInfo data={data} id="PostCard" />
          <LatestBlog />
        </Container>
      </BlogContainer>
    </>
  );
}
